import AudioPlayer from './AudioPlayer';
import './ChapterDisplay.css';

const ChapterDisplay = ({ chapter, chapterText, format, fontSize = 'medium' }) => {
  if (!chapter) {
    return (
      <div className="chapter-display empty">
        <p>No chapter selected</p>
      </div>
    );
  }

  if (!chapterText) {
    return (
      <div className="chapter-display empty">
        <h2>{chapter.book} {chapter.chapter}</h2>
        <p>Chapter text not available</p>
      </div>
    );
  }

  return (
    <article className={`chapter-display font-${fontSize}`}>
      <h2 className="chapter-heading">{chapter.book} {chapter.chapter}</h2>

      <AudioPlayer chapter={chapter} />

      {format === 'html' ? (
        <div
          className="chapter-text html"
          dangerouslySetInnerHTML={{ __html: chapterText.passage }}
        />
      ) : (
        <div className="chapter-text plain">
          {chapterText.passage.split('\n').map((line, index) => (
            line.trim() === ''
              ? <br key={index} />
              : <p key={index} className="verse-line">{line}</p>
          ))}
        </div>
      )}

      <p className="esv-attribution">
        Scripture quotations are from the ESV® Bible (The Holy Bible, English Standard Version®)
      </p>
    </article>
  );
};

export default ChapterDisplay;
